<template>
  <div v-if="can('edit-service')">
    <h2>Edit Service</h2>
    <div class="custom-form">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <ValidationProvider name="title" rules="required" v-slot="{ errors }">
            <div class="form-group my-4">
              <label for="title">Title<Astrik /></label>
              <input
                type="text"
                v-model="form.title"
                class="form-control"
                id="title"
              />
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>

          <ValidationProvider name="Slug" rules="required" v-slot="{ errors }">
            <div class="form-group my-4">
              <label for="title">Slug<Astrik /></label>
              <input
                type="text"
                v-model="form.slug"
                class="form-control"
                id="slug"
              />
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>

          <ValidationProvider
            name="time_period"
            rules="required|integer"
            v-slot="{ errors }"
          >
            <div class="form-group my-4">
              <label for="title">Time Period<Astrik /></label>
              <input
                type="text"
                v-model="form.time_period"
                class="form-control"
                id="time-period"
              />
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>

          <div class="form-group my-4">
            <label for="title">Image</label>
            <input
              type="file"
              @change="onFileChange"
              accept="image/*"
              class="form-control"
              id="image"
            />
          </div>

          <ValidationProvider name="sort" rules="required" v-slot="{ errors }">
            <div class="form-group my-4">
              <label for="title">Sort<Astrik /></label>
              <input
                type="text"
                v-model="form.sort"
                class="form-control"
                id="title"
              />
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>

          <ValidationProvider
            name="status"
            rules="required"
            v-slot="{ errors }"
          >
            <div class="form-group my-4">
              <label for="title">Status<Astrik /></label>
              <select v-model="form.status" class="form-select">
                <option
                  :value="status.value"
                  v-for="(status, index) in $store.state.status"
                  :key="index"
                >
                  {{ status.label }}
                </option>
              </select>
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <div class="button-form-group">
            <button type="submit" class="btn btn-success">Update</button>
            <button type="submit" class="btn btn-danger pull-right">
              Cancel
            </button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
export default {
  name: "EditService",
  data() {
    return {
      form: [],
    };
  },
  mounted() {
    // if (this.can("edit-service")) {
    this.getSingleServiceDetail();
    // } else {
    //   this.$router.push({
    //     name: "Dashboard",
    //   });
    // }
  },
  methods: {
    getSingleServiceDetail() {
      this.$http
        .get("service/" + this.$route.params.id + "/edit")
        .then((res) => {
          this.form = res.data.data;
          this.form.image = null;
        });
    },
    onFileChange(event) {
      this.form.image = event.target.files[0];
      console.log(this.form.image);
    },
    onSubmit() {
      const formData = new FormData();
      formData.append("_method", "PATCH");
      formData.append("title", this.form.title);
      formData.append("slug", this.form.slug);
      formData.append("time_period", this.form.time_period);
      formData.append("status", this.form.status);
      formData.append("sort", this.form.sort);
      if (this.form.image != null) {
        formData.append("image", this.form.image);
      }

      this.$http
        .post("service/" + this.$route.params.id, formData)
        .then((res) => {
          if (res.data.status == 1) {
            this.$notify({
              group: "notifications",
              title: "Service",
              type: "success",
              text: res.data.message,
            });
            this.$router.push("/admin/service");
          } else {
            this.$notify({
              group: "notifications",
              title: res.data.message,
              type: "error",
              text: res.data.errors[0],
            });
          }
        });
    },
  },
};
</script>
